@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
	--bizF-theme-color: #526eb1;
	--bizF-theme-accent: #142f48;
	--bizF-hover-color: #4a64a0;
	--bizF-bullet-bg: #bfdbfe;
}

select {
	appearance: none;
	background-image: url("data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20fill='none'%20viewBox='0%200%2020%2020'%3E%3Cpath%20stroke='%236b7280'%20stroke-linecap='round'%20stroke-linejoin='round'%20stroke-width='1.5'%20d='M6%208l4%204%204-4'/%3E%3C/svg%3E");
	background-position: right 0.5rem center;
	background-repeat: no-repeat;
	background-size: 1.5em 1.5em;
	padding-right: 2.5rem;
	-webkit-print-color-adjust: exact;
	print-color-adjust: exact;
}

@layer components {
	.bizF-input-error {
		@apply bizF-ring-red-500 focus:bizF-ring-red-500;
	}
	.bizF-input-focus {
		@apply bizF-ring-gray-300 focus:bizF-ring-[--bizF-theme-color];
	}
	.bizF-input-default {
		@apply bizF-block bizF-w-full bizF-rounded-md bizF-shadow-sm bizF-border-0 bizF-py-2.5 bizF-px-2.5 bizF-text-gray-900 bizF-ring-1 bizF-outline-1 bizF-outline-gray-900 bizF-ring-inset focus:bizF-ring-1 focus:bizF-ring-inset focus-visible:bizF-outline-[--bizF-theme-color] placeholder:bizF-text-gray-400 bizF-text-base bizF-leading-6 bizF-bg-none;
	}
	.bizF-select-error {
		@apply bizF-ring-red-500 focus:bizF-outline-[--bizF-theme-color];
	}
	.bizF-select-focus {
		@apply bizF-ring-gray-300 focus:bizF-outline-[--bizF-theme-color];
	}
	.bizF-select-default {
		@apply bizF-appearance-none bizF-bg-white bizF-block bizF-w-full bizF-rounded-md bizF-shadow-sm bizF-border-0 bizF-py-2.5 bizF-text-gray-900 bizF-ring-1 focus:bizF-ring-1 bizF-ring-inset bizF-pl-3 placeholder:bizF-text-gray-400 bizF-text-base bizF-leading-6;
	}
	.bizF-label {
		@apply bizF-block bizF-font-semibold bizF-text-base bizF-leading-6 bizF-text-gray-900;
	}
}
